import * as pubsub from 'pubsub';
import { Controller } from 'stimulus';

export class ProductCardController extends Controller {
  static targets = ['block', 'image'];

  #id = '';
  #imageSets = {};
  #preloadedImages = new Set();

  #selectBestImage(srcset) {
    const containerWidth = this.blockTarget.clientWidth * (window.devicePixelRatio || 1);
    const sizes = Object.keys(srcset)
      .map(Number)
      .sort((a, b) => a - b);
    for (let size of sizes) {
      if (containerWidth <= size) return srcset[size] || srcset.full;
    }
    return srcset.full;
  }

  #preloadImage(url) {
    const isPreloaded = this.#preloadedImages.has(url);

    if (isPreloaded) {
      return;
    }

    const preloadedImage = new Image();
    preloadedImage.src = url;
  }

  connect() {
    this.#id = this.blockTarget.dataset.id ?? 'unknown';
    this.#imageSets = JSON.parse(this.imageTarget.dataset.imageSetsValue ?? '{}');

    pubsub.subscribe('products:card:visible', (data) => {
      if (data.id === this.#id) {
        this.#preloadImage(this.#selectBestImage(this.#imageSets.secondary));
      }
    });
  }

  swapToDefaultImage() {
    this.imageTarget.src = this.#selectBestImage(this.#imageSets.default);
  }

  swapToSecondaryImage() {
    this.imageTarget.src = this.#selectBestImage(this.#imageSets.secondary);
  }
}

window.Stimulus.register('product-card', ProductCardController);
